/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_PauseInputs */

const en_jobs_pause = /** @type {(inputs: Jobs_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

const de_jobs_pause = /** @type {(inputs: Jobs_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausieren`)
};

const fr_jobs_pause = /** @type {(inputs: Jobs_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre en pause`)
};

const es_jobs_pause = /** @type {(inputs: Jobs_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausar`)
};

const it_jobs_pause = /** @type {(inputs: Jobs_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sospendi`)
};

const nl_jobs_pause = /** @type {(inputs: Jobs_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauzeren`)
};

const pl_jobs_pause = /** @type {(inputs: Jobs_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wstrzymaj`)
};

const fi_jobs_pause = /** @type {(inputs: Jobs_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keskeytä`)
};

const da_jobs_pause = /** @type {(inputs: Jobs_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

const sv_jobs_pause = /** @type {(inputs: Jobs_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausa`)
};

/**
* | output |
* | --- |
* | "Pause" |
*
* @param {Jobs_PauseInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_pause = /** @type {((inputs?: Jobs_PauseInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_PauseInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_pause(inputs)
	if (locale === "fr") return fr_jobs_pause(inputs)
	if (locale === "es") return es_jobs_pause(inputs)
	if (locale === "it") return it_jobs_pause(inputs)
	if (locale === "nl") return nl_jobs_pause(inputs)
	if (locale === "pl") return pl_jobs_pause(inputs)
	if (locale === "fi") return fi_jobs_pause(inputs)
	if (locale === "da") return da_jobs_pause(inputs)
	if (locale === "sv") return sv_jobs_pause(inputs)
	return en_jobs_pause(inputs)
});